A position profile associated with a workflow process.
